<template>
  <div class="demo-alignment">
    <!--
    <vs-select placeholder="Select Country" v-model="country">
      <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in countries" />
    </vs-select>
    -->

    <vs-select placeholder="Select Region" v-model="region">
      <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in region_list" />
    </vs-select>

    <!--
    <vs-select placeholder="Select Town" v-model="town">
      <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in town_list" />
    </vs-select>
    -->
  </div>
</template>

<script>
import is from 'is_js'

export default {
  name: 'LocationFilter',
  data: () => ({
    country: 'Ghana',
    region: 'All',
    town: 'All',
    countries: [],
    regions: [],
    towns: []
  }),
  computed: {
    region_list() {
      const self = this
      return this.regions.filter(function(x) {
        return is.inArray(self.country, [x.country, 'All'])
      })
    },
    town_list() {
      const self = this
      return this.towns.filter(function(x) {
        return is.inArray(self.region, [x.region, 'All'])
      })
    }
  },
  watch: {
    // country() {
    //   this.region = 'All'
    //   this.sendUpdate()
    // },
    region() {
      this.town = 'All'
      this.sendUpdate()
    }
    // town() {
    //   this.sendUpdate()
    // }
  },
  created() {
    // this.$http
    //   .get('/api/locations/countries')
    //   .then(response => {
    //     this.countries = response.data
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })

    this.$http
      .get('/api/locations/regions')
      .then(response => {
        this.regions = response.data
      })
      .catch(error => {
        console.log(error)
      })

    // this.$http
    //   .get('/api/locations/towns')
    //   .then(response => {
    //     this.towns = response.data
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
  },
  methods: {
    sendUpdate() {
      this.$emit('updated', {
        country: this.country,
        region: this.region,
        town: this.town
      })
    }
  }
}
</script>

<style></style>
